import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Navigation from './navigation';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from './context/ThemeContext.jsx';
import { SidebarProvider } from './context/SidebarContext.jsx';
import { AuthProvider } from './context/AuthContext.jsx';
import './assets/sass/global.scss';

console.info(`Academia Cenit v1.22 — build: 24-junio-2026`);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<AuthProvider>
				<ThemeProvider>
					<SidebarProvider>
						<Navigation />
					</SidebarProvider>
				</ThemeProvider>
			</AuthProvider>
		</BrowserRouter>
	</React.StrictMode>
);

reportWebVitals();
